import { render, staticRenderFns } from "./MessageSearch.vue?vue&type=template&id=23a0ddc6&scoped=true&"
import script from "./MessageSearch.vue?vue&type=script&lang=ts&"
export * from "./MessageSearch.vue?vue&type=script&lang=ts&"
import style0 from "./MessageSearch.vue?vue&type=style&index=0&id=23a0ddc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a0ddc6",
  null
  
)

component.options.__file = "MessageSearch.vue"
export default component.exports